export const main = {
  width: "100%",
  display: "flex",
  position: "fixed",
  bottom: 0,
  height: "64px",
  background: "#FFFFFF",
  boxShadow: "0px -1px 2px rgba(0, 0, 0, 0.12)",
  zIndex: 5,
};

export const menuItem = {
  width: "25%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

export const link = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textDecoration: "none",
  color: "#828282",
};
